import { useState, useCallback, useEffect } from 'react';

export function useValidation(props, errorText, inputRef) {
    const [isInvalid, setisInvalid] = useState(false);
    const [errorTextState, setErrorText] = useState('');

    const validate = useCallback(() => {
        if (props.value) {
            setisInvalid(false);
            setErrorText('');
            return { isInvalid: false };
        }

        setisInvalid(true);
        setErrorText(errorText);
        return {
            ...props,
            isInvalid: true,
            errorText,
        };
    }, [errorText, props]);

    useEffect(() => {
        if (typeof inputRef !== 'function') return undefined;

        inputRef({ validate });
        return () => inputRef(undefined);
    }, [inputRef, validate]);

    useEffect(() => {
        if (props.value && isInvalid) {
            setisInvalid(false);
            setErrorText('');
        }
    }, [isInvalid, props.value]);

    return {errorTextState, isInvalid};
}
